import { OpenAPI } from '@kalba/api-client';
import { getLoginRedirectPath, useAuthStore } from '../stores/auth.store';

let isRefreshing = false;

export function configureApiClient() {
  OpenAPI.BASE = '';

  OpenAPI.TOKEN = async () => useAuthStore.getState().token ?? '';

  OpenAPI.interceptors.response.use(async (response) => {
    if (response.status !== 401) return response;

    // Check if it's a session timeout
    try {
      const cloned = response.clone();
      const body = await cloned.json().catch(() => ({}));
      if (body?.code === 'SESSION_TIMEOUT') {
        const redirectPath = getLoginRedirectPath(useAuthStore.getState().licensingAuthorities);
        useAuthStore.getState().clearSession();
        useAuthStore.setState({ sessionTimedOut: true, timeoutRedirectPath: redirectPath });
        return response;
      }
    } catch {
      // ignore
    }

    if (isRefreshing) {
      const redirectPath = getLoginRedirectPath(useAuthStore.getState().licensingAuthorities);
      useAuthStore.getState().clearSession();
      window.location.href = redirectPath;
      return response;
    }
    isRefreshing = true;
    try {
      const refreshRes = await fetch('/api/v1/auth/refresh', {
        method: 'POST',
        credentials: 'include',
      });
      if (!refreshRes.ok) throw new Error('refresh failed');
      const data = (await refreshRes.json()) as {
        accessToken: string;
        user: {
          id: string;
          email: string;
          name: string;
          avatarUrl?: string | null;
          permissions: string[];
          licensingAuthorities?: string[];
        };
      };
      useAuthStore.getState().setSession(
        {
          id: data.user.id,
          email: data.user.email,
          name: data.user.name,
          avatarUrl: data.user.avatarUrl,
        },
        data.user.permissions,
        data.accessToken,
        false,
        data.user.licensingAuthorities ?? [],
      );
    } catch {
      useAuthStore.getState().clearSession();
    } finally {
      isRefreshing = false;
    }
    return response;
  });
}
